import styled from 'styled-components';

export const UploadAreaContainer = styled.div`
  display: flex;
  flex-direction: row;

  & > span {
    width: 100%;
    margin: 0.5rem;
    align-items: center;
    justify-content: center;
  }

  & .hefesto-button__container {
    width: 14.7rem;
  }

  & .ant-upload-drag-container > div > span {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0em;
    align-items: center;
    text-align: center;
    min-width: 31.75rem;
  }

  & div.ant-upload-drag-container > div {
    align-items: center;
    justify-content: center;
  }
`;

export const Subtitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};
  margin: 1rem auto;

  .hefesto-link {
    text-decoration: underline;
    font-size: 1rem;
    font-weight: bold;
  }
`;

export const Container = styled.div`
  padding: 0 1.5rem 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white4};
  margin-bottom: 0.5rem;
`;
